import { Link } from '@remix-run/react';

const platformLinks = [
  { name: 'X (Twitter) Scheduler', path: '/tools/x-twitter-scheduler' },
  { name: 'Instagram Scheduler', path: '/tools/instagram-scheduler' },
  { name: 'LinkedIn Scheduler', path: '/tools/linkedin-scheduler' },
  { name: 'Facebook Scheduler', path: '/tools/facebook-scheduler' },
  { name: 'TikTok Scheduler', path: '/tools/tiktok-scheduler' },
  { name: 'YouTube Scheduler', path: '/tools/youtube-scheduler' },
  { name: 'Bluesky Scheduler', path: '/tools/bluesky-scheduler' },
  { name: 'Threads Scheduler', path: '/tools/threads-scheduler' },
];

export default function Footer() {
  return (
    <footer className="bg-gray-50 text-gray-900 py-12 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {/* Platforms Section */}
          <div className="lg:col-span-2">
            <h4 className="font-semibold mb-4">Platforms</h4>
            <ul className="grid grid-cols-2 gap-2 text-gray-600 text-sm">
              {platformLinks
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="hover:text-gray-900 transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          {/* Links Section */}
          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li>
                <Link to="/tools" className="hover:text-gray-900 transition-colors">
                  Free Tools
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-gray-900 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-gray-900 transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/agents" className="hover:text-gray-900 transition-colors">
                  For AI Agents (MCP)
                </Link>
              </li>
              <li>
                <Link to="/docs/api" reloadDocument className="hover:text-gray-900 transition-colors">
                  API Docs
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li>
                <Link to="/about" className="hover:text-gray-900 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/features" className="hover:text-gray-900 transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gray-900 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-gray-900 transition-colors">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/tos" className="hover:text-gray-900 transition-colors">
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Oversized brand wordmark */}
        <div className="border-t border-gray-200 mt-8 pt-10">
          <div
            aria-hidden="true"
            className="select-none font-bold tracking-tight leading-none text-gray-900 text-[clamp(3.5rem,18vw,16rem)]"
          >
            TheTabber
          </div>
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-gray-500 text-sm">
            <p>&copy; {new Date().getFullYear()} TheTabber. All rights reserved.</p>
            <p>Publish everywhere from one place.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
